const translation = {
  // Nav
  nav_home: "Home",
  nav_back_home: "Back to Home",
  nav_about: "About",
  nav_menu: "Menu",
  nav_gallery: "Gallery",
  nav_testimonials: "Testimonials",
  nav_contact: "Contact",
  nav_reserve: "Book a Table",

  // Hero
  hero_since: "Since 1994",
  hero_title_1: "Cantinho",
  hero_title_2: "do Cais",
  hero_subtitle: "Azorean cuisine with authentic flavours and a family atmosphere where you feel right at home.",
  hero_cta_menu: "View Menu",
  hero_cta_reserve: "Book a Table",
  hero_scroll: "Explore",

  // About
  about_label: "Our Story",
  about_title_1: "Tradition and Passion",
  about_title_2: "in Every Dish",
  about_p1: "Cantinho do Cais was born from a deep connection to the sea and the Azorean fishing soul. Originally founded in Porto Formoso, next to the old pier where traditional boats docked, the restaurant earned its name from its proximity to the small local fish auction — the place where fish jumped straight from the nets into the hands of our kitchen.",
  about_p2: "Time brought new challenges and the restaurant eventually was reborn in São Brás. Although the waters of the pier were left behind physically, the essence and the name remained intact, carrying with them the memories, respect for the sea and the tradition built over decades.",
  about_p3: "Today, we continue to be a proudly family-run space, where simplicity, hospitality and the authentic flavours of São Miguel Island come together at the table. Every day, Mr. Jorge keeps alive the spirit of buying fresh fish, visiting the market to personally select the best specimens that arrive in our kitchen.",
  about_p4: "Specialists in fish and regional cuisine, we honour the Azorean palate through our famous Fish Soup, the traditional Fish Stew and delicacies prepared with species from our coast — such as Blackspot Seabream, Blackbelly Rosefish, Forkbeard, Alfonsino, Tuna, Octopus, among other fish and seafood selected daily. Whether in grilled dishes that respect the freshness of the sea or in more elaborate Azorean recipes, each dish celebrates the best of the island. Between timeless secrets and homemade desserts, we open our doors so that every customer truly feels at home.",
  about_cta: "Meet Our Team",
  about_stat_1_num: "30+",
  about_stat_1_label: "Years of Experience",
  about_stat_2_num: "90%+",
  about_stat_2_label: "Local Ingredients",
  about_stat_3_num: "4.5★",
  about_stat_3_label: "Average Rating",
  about_quote_text: "A memorable gastronomic experience.",

  // Menu Categories & Prices
  menu_label: "Menu",
  menu_title_1: "Discover Our",
  menu_title_2: "Unique Flavours",
  menu_subtitle: "A carefully curated selection of dishes celebrating the richness of the Azores",
  menu_from: "From",
  menu_view: "View Dishes",
  menu_cat_starters: "Starters",
  menu_cat_starters_desc: "Limpets, mussels, shrimp, fish soup and island snacks to start with flavour.",
  menu_cat_fish: "Fish Dishes",
  menu_cat_fish_desc: "Fish Stew, Octopus, Blackbelly Rosefish, Forkbeard, Alfonsino and more, from the grill or in elaborate dishes.",
  menu_cat_meat: "Meat Dishes",
  menu_cat_meat_desc: "Roasts, veal steak and other meat dishes prepared with the finest Azorean ingredients.",
  menu_cat_vegetarian: "Vegetarian Dishes",
  menu_cat_vegetarian_desc: "Fresh salads, seasonal vegetables and vegetarian dishes made with local Azorean produce.",
  menu_cat_kids: "Kids Menu",
  menu_cat_kids_desc: "Balanced and tasty meals, specially designed for the little ones.",
  menu_cat_desserts: "Desserts",
  menu_cat_desserts_desc: "Queijadas, traditional fruits and homemade desserts to finish on a high note.",
  menu_price_starters: "€3.50",
  menu_price_fish: "€10.00",
  menu_price_meat: "€10.00",
  menu_price_vegetarian: "€7.50",
  menu_price_kids: "€6.50",
  menu_price_desserts: "€1.20",
  
  // Price List & Drinks
  menu_suggestion_question: "Did you like our suggestions?",
  menu_full_price_list: "See Full Price List & Wine Menu",
  menu_section_food: "Food",
  menu_section_drinks: "Drinks",
  menu_cat_vines: "Wines",
  menu_cat_reds: "Reds",
  menu_cat_whites: "Whites",
  menu_cat_greens_alvarinhos: "Green & Alvarinho Wines",
  menu_cat_roses: "Rosés",
  menu_cat_sparkling: "Sparkling Wines",
  menu_cat_brewery: "Brewery & Beers",
  menu_cat_águas: "Waters",
  menu_cat_sumos: "Juices",
  menu_cat_licores: "Liqueurs",
  menu_cat_aguardentes: "Spirits & Aguardentes",
  menu_cat_brandys: "Brandies",
  menu_cat_whiskys: "Whiskys",

  // Brewery Items Descriptions / Translations
  cerveja_fino: "Draft Beer (small glass)",
  cerveja_tulipa: "Draft Beer (large glass / Tulip)",
  cerveja_caneca: "Beer Mug",
  cerveja_garrafa: "Bottle",
  cerveja_panache: "Panaché (beer mixed with Sprite)",
  cerveja_caldeado_cerveja: "Caldeado with beer (beer and wine mix)",
  cerveja_caldeado_vinho: "Caldeado with wine (wine and beer mix)",

  // Waters (EN)
  agua_sem_gas: "Still Water",
  agua_com_gas: "Sparkling Water",
  agua_tonica: "Tonic Water",

  // Shots / Riscos (EN)
  bebida_risco_licor: "Liqueur Shot",
  bebida_risco_brandy: "Brandy Shot",
  bebida_risco_whisky: "New Whisky Shot",

  // Wine Regions
  regiao_alentejo: "Alentejo",
  regiao_douro: "Douro",
  regiao_dão: "Dão",
  regiao_outras_regiões: "Other Regions",

  // Modals
  modal_close: "Close",
  modal_availability: "Availability subject to season and daily stock",
  modal_starters_title: "Our Starters",
  modal_fish_title: "Our Fish Dishes",
  modal_meat_title: "Our Meat Dishes",
  modal_vegetarian_title: "Our Vegetarian Dishes",
  modal_kids_title: "Our Kids Menu",
  modal_desserts_title: "Our Desserts",

  // All Dishes (Unified list - No duplicates)
  dish_salada_queijo_fresco: "Fresh Cheese Salad",
  dish_omeletes: "Omelettes",
  dish_salada_feijao: "Bean Salad",
  dish_filetes_fritos: "Fried Fish Fillets",
  dish_lombinhos: "Pork Tenderloin Fillets",
  dish_hamburguer_prato: "Burger Plate",
  dish_note_sob_consulta: "(upon inquiry)",
  dish_note_por_encomenda: "(available by request)",
  dish_camarao: "Shrimp",
  dish_favas_guisadas: "Stewed Broad Beans",
  dish_iscas_atum: "Tuna Bites",
  dish_lapas_grelhadas: "Grilled Limpets",
  dish_mexilhoes_grelhados: "Grilled Mussels",
  dish_queijo_curado: "Cured Cheese",
  dish_queijo_fresco: "Fresh Cheese",
  dish_sopa_peixe: "Fish Soup",
  dish_atum: "Tuna",
  dish_bacalhau: "Codfish",
  dish_chicharros_fritos: "Fried Horse Mackerel",
  dish_lulas_grelhadas: "Grilled Squid",
  dish_peixe_grelhado: "Grilled Fish",
  dish_polvo_assado: "Roasted Octopus",
  dish_polvo_guisado: "Stewed Octopus",
  dish_molho_peixe: "Fish Stew",
  dish_assaduras: "Traditional Pork Bites",
  dish_bifanas: "Traditional Sliced Pork",
  dish_bife_novilho: "Veal Steak",
  dish_peito_frango: "Chicken Breast",
  dish_ananas: "Pineapple",
  dish_gelados: "Ice Creams",
  dish_queijadas: "Queijadas",

  // Gallery
  gallery_label: "Gallery",
  gallery_title: "Unforgettable Moments",
  gallery_subtitle: "A visual journey through our kitchen, atmosphere and flavours",

  // Testimonials
  testimonials_label: "Testimonials",
  testimonials_title_1: "What Our",
  testimonials_title_2: "Customers Say",
  testimonials_prev: "Previous",
  testimonials_next: "Next",

  // Reservations & Contact
  reservations_label: "Reservations",
  reservations_title: "Book Your Table",
  reservations_subtitle: "Choose a day and get in touch with us",
  reservations_prev_month: "Previous month",
  reservations_next_month: "Next month",
  reservations_modal_title: "Reservation for",
  reservations_modal_subtitle: "How would you like to make your reservation?",
  reservations_phone_title: "Book by Phone",
  reservations_phone_desc: "During the call, please provide the day, desired time, reservation name, number of guests and contact details.",
  reservations_phone_cta: "Call Now",
  reservations_email_title: "Request by Email",
  reservations_email_desc: "We will open a pre-filled email with the selected day. Complete the remaining details.",
  reservations_email_cta: "Send Email",
  reservations_close: "Close",
  reservations_email_subject: "Reservation Request - Cantinho do Cais",
  reservations_email_body: "Hello,\n\nI would like to make a reservation with the following details:\n\nDate: {date}\nTime: [fill in]\nName for the reservation: [fill in]\nNumber of guests: [fill in]\nContact: [fill in]\n\nThank you and I look forward to hearing from you.\n\n---\n⚠️ Note: If this reservation is made less than 12 hours in advance, please call the restaurant (296 442 631) to confirm availability.",
  contact_label: "Contact",
  contact_title: "Come Visit Us",
  contact_subtitle: "We are waiting for you in São Brás, Azores",
  contact_address_label: "Address",
  contact_address: "Rua do Ramal 1, 9625-510 São Brás",
  contact_phone_label: "Phone",
  contact_phone: "296 442 631",
  contact_hours_label: "Opening Hours",
  contact_hours_1: "Monday, Tuesday, Thursday to Sunday: 12:00 – 22:00",
  contact_hours_2: "Wednesday: Closed",
  contact_form_title: "Send Us a Message",
  contact_form_name: "Name",
  contact_form_email: "Email",
  contact_form_message: "Message",
  contact_form_submit: "Send Message",
  contact_form_success: "Message sent successfully! We will be in touch shortly.",
  contact_form_error: "An error occurred. Please try again.",
  contact_call_cta: "Call Now",

  // Footer
  footer_tagline: "Azorean cuisine with authentic flavours in São Brás",
  footer_nav_title: "Quick Links",
  footer_info_title: "Information",
  footer_legal_title: "Legal",
  footer_privacy: "Privacy Policy",
  footer_terms: "Terms of Use",
  footer_cookies: "Cookies Policy",
  footer_copyright: "© 2026 Cantinho do Cais. All rights reserved.",
  footer_developed_by: "Developed by Ponto Zero Apps",
  footer_newsletter_title: "News & Promotions",
  footer_newsletter_desc: "Receive our latest news and special promotions",
  footer_newsletter_placeholder: "Your email",
  footer_newsletter_cta: "Subscribe",
  footer_made_with: "Made with",
  footer_in: "in the Azores",
  footer_complaints: "Complaints Book",

  // --- PÁGINAS LEGAIS (LEGAL PAGES) ---

  // Cookies
  cookies_title: "Cookies Policy",
  cookies_intro_1: "The ",
  cookies_intro_2: " website uses cookies to ensure we provide you with the best browsing experience.",
  cookies_h1: "1. What are Cookies?",
  cookies_p1: "Cookies are small text files saved on your computer or mobile device through your web browser. These files allow the website to \"remember\" your actions and preferences (such as your chosen language) over a period of time.",
  cookies_h2: "2. What Cookies do we use?",
  cookies_p2_1: "Our website only uses ",
  cookies_p2_2: " and ",
  cookies_p2_strong1: "Strictly Necessary Cookies",
  cookies_p2_strong2: "Functional Cookies",
  cookies_li1_strong: "Language Cookies:",
  cookies_li1_text: " Used to remember the language (Portuguese, English, or German) you have chosen to browse the site, so you do not have to select it again every time you visit a new page.",
  cookies_li2_strong: "Performance/Analytics Cookies:",
  cookies_li2_text: " We use anonymous analytical tools that do not collect personal data (do not track IP or identify the user), serving only to count visits and improve site performance.",
  cookies_p3: "We do not use targeted advertising or third-party marketing cookies.",
  cookies_h3: "3. How to Manage Cookies?",
  cookies_p4: "You can block or delete cookies in your browser settings at any time. However, by disabling cookies, some website functionalities (such as language memory) may no longer function correctly. For more information on how to manage cookies, please refer to the \"Help\" section of your browser.",

  // Privacidade
  privacy_title: "Privacy Policy",
  privacy_intro_1: "",
  privacy_intro_2: " respects the privacy of all users of its website and is committed to protecting the personal information that each user decides to share.",
  privacy_h1: "1. Data Collection",
  privacy_p1: "When browsing our website, we do not collect personal information automatically. The only personal data we have access to are those you voluntarily provide when contacting us by phone (such as name, phone number, and reservation details).",
  privacy_h2: "2. Data Usage",
  privacy_p2: "The data provided will be used exclusively to:",
  privacy_li1: "Respond to requests for information or contact.",
  privacy_li2: "Process and manage table reservation requests.",
  privacy_li3: "Improve the user experience in our space.",
  privacy_h3: "3. Data Sharing",
  privacy_p3: "Cantinho do Cais does not sell, rent, or share your personal data with third parties, except when strictly necessary to comply with legal obligations.",
  privacy_h4: "4. Data Retention",
  privacy_p4: "Your data will be kept only for the time necessary for the purpose for which they were collected (for example, until the date of your reservation or completion of your contact request).",
  privacy_h5: "5. Your Rights",
  privacy_p5: "Under the GDPR, you have the right to request access to, rectification, or erasure of your personal data. To exercise these rights, please contact us by phone at 296 442 631 or in person at our address: Rua do Ramal 1, 9625-510 São Brás, Azores.",
  privacy_h6: "6. Changes to this Policy",
  privacy_p6: "We reserve the right to update this Privacy Policy whenever necessary. We recommend periodically checking this page.",

  // Termos
  terms_title: "Terms of Use",
  terms_intro_1: "Welcome to the ",
  terms_intro_2: " website. By accessing and using this website, you agree to comply with the following terms and conditions.",
  terms_h1: "1. Website Purpose",
  terms_p1: "This website is strictly informative, intended to present our space, menu, opening hours, location, and contact/reservation methods.",
  terms_h2: "2. Menu Information and Prices",
  terms_p2: "We make every effort to ensure that the information presented on the website is up to date. However, prices, dishes, and product availability (especially fresh fish and seafood) are subject to change without prior notice, depending on the daily market and season. The images shown in the gallery are for illustrative purposes only.",
  terms_h3: "3. Intellectual Property",
  terms_p3: "All content on this website, including texts, logos, graphics, and images, is the property of Cantinho do Cais or licensed for our use, and is protected by copyright laws. Reproduction, modification, or distribution of any content without prior authorization is strictly prohibited.",
  terms_h4: "4. Reservations",
  terms_p4: "All table reservations must be made exclusively by direct telephone contact to the restaurant, subject to availability confirmation.",
  terms_h5: "5. Limitation of Liability",
  terms_p5: "Cantinho do Cais is not responsible for any damages or technical issues resulting from the use of this website or external links to other platforms (such as the Electronic Complaints Book).",
  terms_h6: "6. Contacts",
  terms_p6: "For any questions regarding these Terms of Use, please contact us by phone at 296 442 631 or visit us at Rua do Ramal 1, 9625-510 São Brás."
};

export default translation;